import React from 'react';

const Benefits = () => {
  return (
    <>
      <section className='career-promo ptb-120 bg-light'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-10 col-md-12'>
              <div className='section-heading text-center'>
                <h4 className='h5 text-primary'>Why Join Us</h4>
                <h2>Benefits to your business</h2>
                <p>
                  Our payment solutions are integrated with industry-leading systems, including global distribution systems (GDS),
                  central reservation systems (CRS), eCommerce platforms, subscription software and retailer software providers.
                  This allows you to streamline payment management effortlessly, without the complexities of additional integrations.{' '}
                </p>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-0 p-5 bg-white rounded-custom'>
                <span className='fas fa-earth-americas fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Payments made global</h5>
                  <p className='mb-0'>
                    Accept online payments worldwide with our powerful end-to-end solution and offer customers their preferred
                    checkout options.{' '}
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 mt-xl-0 mt-lg-0 mt-md-0 p-5 bg-white rounded-custom'>
                <span className='fas fa-ballot-check fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Payments made customisable</h5>
                  <p className='mb-0'>
                    Offer a quick and easy checkout experience for customers, reducing shopping cart abandonment rates.
                    <br/>
                    <br/>
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 p-5 bg-white rounded-custom'>
                <span className='fas fa-user-friends fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Payments made insightful</h5>
                  <p className='mb-0'>
                    Through payment data analysis, we enable you to make data-driven decisions for optimal performance.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 p-5 bg-white rounded-custom'>
                <span className='fas fa-shield fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Payments made secure</h5>
                  <p className='mb-0'>
                    Safeguard your transactions with sophisticated risk and fraud management tools.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 p-5 bg-white rounded-custom'>
                <span className='fas fa-money-bills fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Payments made for you</h5>
                  <p className='mb-0'>
                    24/7 technical support, a dedicated account manager and risk analyst, all to take care of your needs.
                  </p>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-lg-6'>
              <div className='single-feature d-flex mt-4 p-5 bg-white rounded-custom'>
                <span className='fas fa-brain-circuit fa-2x text-primary'></span>
                <div className='ms-4 mt-2'>
                  <h5>Payments made intelligent</h5>
                  <p className='mb-0'>
                    Our global gateway is designed to empower businesses of any size to accept payments seamlessly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Benefits;
